// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"648":"Froala/Froala","784":"NewTextbox-FroalaEditor"}[chunkId] || chunkId) + "." + {"648":"a8790dd8","784":"33adfba3","945":"767bcbc6"}[chunkId] + ".chunk.css";
};